// extracted by mini-css-extract-plugin
export default {"smallerMargins":"GameErrorModal-module__smallerMargins"};